import { createReducer, on } from '@ngrx/store';

import * as actions from '@abandoned-reservation/store/actions/abandoned-reservation.actions';

export const initialState = false;

export const isLoadingCancellationReducer = createReducer(
  initialState,
  on(actions.cancelAbandonedReservationAction, () => true),
  on(actions.cancelAbandonedReservationErrorAction, () => initialState),
  on(actions.cancelAbandonedReservationSuccessAction, () => initialState),
);
